import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setEditCollectionModal } from "./EditCollectionModalSlice";
import { JSX, useState } from "react";
import {
    useLazyGetCollectionsQuery,
    useUpdateCollectionMutation,
} from "../../pages/collectionsPage/CollectionsSlice";
import { Modal, Button } from "@hatch-digital-nl/bravilor-storybook";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

export const EditCollectionModalContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { t } = useStringTranslation();

    const { collections } = useAppSelector((state) => state.collections);
    const { collectionId } = useAppSelector(
        (state) => state.editCollectionModal,
    );

    const collectionName =
        collections.find((item: { id: number }) => item.id === collectionId)
            ?.name || "";

    const [loading, setLoading] = useState<boolean>(false);
    const [collectionNameInput, setCollectionNameInput] =
        useState<string>(collectionName);

    const [updateCollectionTrigger] = useUpdateCollectionMutation();
    const [collectionTrigger] = useLazyGetCollectionsQuery();

    const paramObject = {
        collectionId: collectionId,
        collectionName: collectionNameInput,
        productIds:
            collections.find((item: { id: number }) => item.id === collectionId)
                ?.productIds || [],
    };

    const handleClose = (): void => {
        dispatch(
            setEditCollectionModal({
                showPopup: false,
            }),
        );
    };

    return (
        <Modal onClose={handleClose} loading={loading}>
            <header className="c-modal__header">
                <h2>{t("edit-collection-name")}</h2>
            </header>
            <div className="c-modal__body">
                <p>{t("do-you-want-to-change-the-name-of-this-collection")}</p>

                <div className="c-modal__body__input">
                    <label>{t("collection-name")}</label>
                    <input
                        type="text"
                        value={collectionNameInput}
                        onChange={(e) => setCollectionNameInput(e.target.value)}
                    />
                </div>

                <div className="c-modal__body__buttons">
                    <Button
                        variant={"primary"}
                        onClick={() => {
                            setLoading(true);
                            updateCollectionTrigger(paramObject).then(() => {
                                collectionTrigger().then(() => {
                                    setLoading(false);
                                    dispatch(
                                        setEditCollectionModal({
                                            showPopup: false,
                                        }),
                                    );
                                });
                            });
                        }}
                    >
                        <span>{t("save-collection-name")}</span>
                    </Button>

                    <Button
                        variant={"secondary"}
                        onClick={() => {
                            dispatch(
                                setEditCollectionModal({
                                    showPopup: false,
                                }),
                            );
                        }}
                    >
                        <span>{t("cancel")}</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
